import { apiUrl } from '../constants/apiConsts';
import fetchRequest from '../utils/request';
import { getHeaders } from './helpers';

class BannerApi {
  static fetchBanner() {
    const request = new Request(`${apiUrl}/content/file/promo_banner`, {
      method: 'GET',
      headers: getHeaders(),
    });
    return fetchRequest(request);
  }
}
  
  export default BannerApi;